<section
  class="relative min-h-full overflow-y-auto overflow-x-hidden flex items-center justify-center"
>
  <!-- Circular blur -->
  <div
    class="max-md:hidden absolute right-1/2 translate-x-80 size-96 bg-ppdms-primary rounded-full opacity-60 blur-[130px]"
  ></div>

  <div
    class="z-10 grid grid-cols-1 lg:grid-cols-2 grid-rows-1 items-center justify-center gap-14"
  >
    <!-- Left Side -->
    <div>
      <div data-aos="fade-right" class="mb-2 flex items-center gap-2">
        <!-- Fuel Icon -->
        <iconify-icon
          icon="lucide:fuel"
          class="text-3xl text-ppdms-light"
        ></iconify-icon>

        <div class="text-ppdms-light">
          <p class="text-xs font-normal">Anambra State Government</p>
          <p class="text-xs font-bold">
            Ministry of Petroleum and Mineral Resources
          </p>
        </div>
      </div>

      <h2
        data-aos="fade-right"
        data-aos-delay="100"
        class="mb-3 text-ppdms-light text-5xl font-bold"
      >
        PPDMS
      </h2>

      <p
        data-aos="fade-right"
        data-aos-delay="200"
        class="mb-2 text-2xl text-ppdms-primary font-bold"
      >
        Filling Station Automation Module
      </p>

      <p
        data-aos="fade-right"
        data-aos-delay="300"
        class="text-sm text-ppdms-light leading-7"
      >
        The PPDMS platform is a comprehensive digital management solution
        developed to automate end-to-end operational processes. From user
        registration and profiling to payment processing, approvals, certificate
        generation, and executive reporting, the platform ensures a smooth and
        transparent workflow for administrators, stakeholders, and users.
      </p>

      <div class="mt-5 flex flex-col md:flex-row gap-3">
        <button
          data-aos="fade-right"
          data-aos-delay="500"
          routerLink="/auth/signup"
          class="app-button app-button-primary"
        >
          <p>Get Started</p>
          <iconify-icon icon="line-md:arrow-right"></iconify-icon>
        </button>
        <button
          data-aos="fade-right"
          data-aos-delay="400"
          routerLink="/auth/login"
          class="app-button app-button-light"
        >
          <p>Login to Portal</p>
          <iconify-icon icon="line-md:arrow-right"></iconify-icon>
        </button>
      </div>
    </div>

    <!-- Right Side -->
    <div class="right-grid">
      <div
        data-aos="fade-left"
        data-aos-offset="-500"
        class="right-grid__card gradient-border-transparent-bg"
      >
        <iconify-icon
          icon="lucide:building-2"
          class="right-grid__card__icon text-ppdms-green"
        ></iconify-icon>
        <div>
          <p class="right-grid__card__count">102</p>
          <p class="right-grid__card__info">Registered Stations</p>
        </div>
      </div>

      <div
        data-aos="fade-left"
        data-aos-delay="100"
        data-aos-offset="-500"
        class="rounded-lg overflow-hidden"
      >
        <img
          class="h-[159px] w-full hover:scale-105 duration-300"
          src="/images/landing-page-1.png"
          alt=""
        />
      </div>

      <div
        data-aos="fade-left"
        data-aos-delay="200"
        data-aos-offset="-500"
        class="right-grid__card"
      >
        <iconify-icon
          icon="lucide:clipboard-clock"
          class="right-grid__card__icon text-ppdms-orange"
        ></iconify-icon>
        <div>
          <p class="right-grid__card__count">102</p>
          <p class="right-grid__card__info">Pending Inspections</p>
        </div>
      </div>

      <div
        data-aos="fade-left"
        data-aos-delay="300"
        data-aos-offset="-500"
        class="right-grid__card"
      >
        <iconify-icon
          icon="lucide:receipt"
          class="right-grid__card__icon text-ppdms-sky"
        ></iconify-icon>
        <div>
          <p class="right-grid__card__count">
            {{ 102 | currency: "NGN" : "symbol-narrow" }}
          </p>
          <p class="right-grid__card__info">Revenue Collected (YTD)</p>
        </div>
      </div>
    </div>
  </div>
</section>
